import React, { useEffect, useState } from "react";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";

import * as XLSX from "xlsx";
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';

import ApproverSeePage from "./ApproverSubmittedSee";

import { GET_APPROVER_TRACK_CI } from "../../AppConstant";

function ApproverTrack({ userDetails, setParentLoading }) {

    const [isApproved, setIsApproved] = useState(false);
    const [submitted, setSubmitted] = useState([]);
    const [selectedItem, setSelectedItem] = useState("");

    const [showSeeModal, setShowSeeModal] = useState(false);

    const getSubmitted = async () => {

        try {
            setParentLoading(true);
            const emailid = localStorage.getItem("emailid");

            const res = await axios.get(GET_APPROVER_TRACK_CI, {
                params: { "approveremail": emailid }
            });
            setSubmitted(res.data);
            console.log("API response:", res.data);
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
        } catch (err) {
            setTimeout(() => {
                setParentLoading(false);
            }, 500);
            console.error(err);
        }
    };

    const handleOpenSeeModal = async (item) => {
        localStorage.setItem('swipexid', item.id)
        localStorage.setItem('swipexempid', item.empid)

        if (item.isapproverapproved == "approved" || item.isapproverapproved == "rejected" || item.status == "F" || item.status == "A" || item.status == "U") {
            setIsApproved(true);
        } else {
            setIsApproved(false);
        }

        setParentLoading(true);
        setShowSeeModal(true);
        setTimeout(() => {
            setParentLoading(false);
        }, 500);
    };

    const handleCloseSeeModal = () => {
        setParentLoading(true);
        setShowSeeModal(false);
        setTimeout(() => {
            setParentLoading(false);
        }, 500);
    };

    useEffect(() => {
        getSubmitted();
    }, []);

    const generateStage = (item) => {

        const normalize = (val) =>
            val === null || val === undefined || val === ""
                ? null
                : val.toString().trim().toLowerCase();

        const VA = normalize(item.isvalidatorapproved);
        const AA = normalize(item.isapproverapproved);
        const status = item.status;


        if (status === "U") {
            // return "Update request have been given, please update it, check comments for more details"
            return "";
        }

        if (!VA) {
            // return "Pending with Reporting Manager";
            return "Validator";
        }

        if (VA === "rejected") {
            // return "Rejected (Reporting Manager)";
            return "Validator";
        }

        if (VA === "approved" && !AA) {
            // return "Pending with Approver";
            return "Approver";
        }

        if (AA === "rejected") {
            // return "Rejected (Approver)";
            return "Approver";
        }

        if (status === "A") {
            // return "ACCEPTED";
            return "";
        }

        return "Unknown";
    };

    const [searchTerm, setSearchTerm] = useState("");
    const [validatorFilter, setValidatorFilter] = useState("All");
    const [approverFilter, setApproverFilter] = useState("All");


    // const filteredRecords = submitted.filter((item) => {
    //     const searchableText = [
    //         ...Object.values(item),
    //         generateStage(item)
    //     ]
    //         .join(" ")
    //         .toLowerCase();

    //     return searchableText.includes(searchTerm.toLowerCase());
    // });


    const getValidatorStatus = (item) => {
        if (item.status === "U") {
            return "Update";
        }

        if (item.isvalidatorapproved === "approved") {
            return "Approved";
        }

        if (item.isvalidatorapproved === "rejected") {
            return "Rejected";
        }

        return "Pending";
    };

    const getApproverStatus = (item) => {
        if (item.status === "U") {
            return "Update";
        }

        if (item.isapproverapproved === "approved") {
            return "Approved";
        }

        if (item.isapproverapproved === "rejected") {
            return "Rejected";
        }

        return "Pending";
    };

    const filteredRecords = submitted.filter((item) => {
        const searchableText = [
            ...Object.values(item),
            generateStage(item)
        ]
            .join(" ")
            .toLowerCase();

        const matchesSearch = searchableText.includes(
            searchTerm.toLowerCase()
        );

        const validatorStatus = getValidatorStatus(item);
        const approverStatus = getApproverStatus(item);

        const matchesValidator =
            validatorFilter === "All" ||
            validatorStatus === validatorFilter;

        const matchesApprover =
            approverFilter === "All" ||
            approverStatus === approverFilter;

        return (
            matchesSearch &&
            matchesValidator &&
            matchesApprover
        );
    });

    const [expandedComment, setExpandedComment] = useState(null);

    const handleSeeMore = (index) => {
        setExpandedComment(expandedComment === index ? null : index);
    };

    const handleDownloadExcel = () => {
        if (submitted.length === 0) {
            alert("No records available to download.");
            return;
        }

        // Use submitted, NOT filteredRecords
        const excelData = submitted.map((sub) => ({
            "SWIPEX ID": sub.id || "",
            "EMP ID": sub.empid || "",
            "NAME": sub.empname || "",
            "VALIDATOR NAME": sub.validatorname || "",
            "TITLE": sub.title || "",
            "VALIDATOR": getValidatorStatus(sub),
            "APPROVER": getApproverStatus(sub),
            "LOCATION": sub.location || "",
            "COMMENTS": sub.comments || "",
            "CREATED AT": sub.createdat
                ? new Date(
                    sub.createdat.replace(" ", "T")
                ).toLocaleString("en-GB")
                : ""
        }));

        // Create worksheet
        const worksheet = XLSX.utils.json_to_sheet(excelData);

        // Column widths
        worksheet["!cols"] = [
            { wch: 20 }, // SWIPEX ID
            { wch: 15 }, // EMP ID
            { wch: 25 }, // NAME
            { wch: 25 }, // VALIDATOR NAME
            { wch: 40 }, // TITLE
            { wch: 15 }, // VALIDATOR
            { wch: 15 }, // APPROVER
            { wch: 20 }, // LOCATION
            { wch: 50 }, // COMMENTS
            { wch: 22 }  // CREATED AT
        ];

        // Create workbook
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "SWIPEX"
        );

        // Download
        XLSX.writeFile(
            workbook,
            "SWIPEX_All_Records.xlsx"
        );
    };



    return (
        <div>

            <div
                className="d-flex align-items-center mb-3"
                style={{ gap: "10px" }}
            >
                <div
                    className="input-group"
                    style={{ width: "500px" }}
                >
                    <span className="input-group-text">
                        <i className="bi bi-search"></i>
                    </span>

                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>

               <DownloadForOfflineIcon
        onClick={handleDownloadExcel}
        titleAccess="Download All Records"
        sx={{
            color: "black",
            fontSize: 30,
            cursor: "pointer",
            "&:hover": {
                color: "blue"
            }
        }}
    />
            </div>



            <table className="mt-1 fw-bold" style={{ fontSize: "small" }}>
                <thead className="bg-success-subtle" style={{ width: "100%", color: "green" }} >
                    <tr style={{ width: "3%" }}>
                        <th style={{ width: "3%" }}>S.No</th>
                        <th style={{ width: "10%" }}>SWIPEX ID</th>
                        <th style={{ width: "7%" }}>EMPLOYEE ID</th>
                        <th style={{ width: "10%" }}>EMPLOYEE NAME</th>
                        <th style={{ width: "10%" }}>VALIDATOR</th>
                        <th style={{ width: "10%" }}>TITLE </th>

                        <th style={{ width: "8%", textAlign: "center" }}>
                            <div>
                                <span>VALIDATOR</span>

                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}
                                >
                                    <span style={{ color: "indigo", fontSize: "12px" }}>
                                        ( {validatorFilter} )
                                    </span>

                                    <select className=""
                                        value={validatorFilter}
                                        onChange={(e) => setValidatorFilter(e.target.value)}
                                        style={{
                                            border: "none",
                                            background: "transparent",
                                            cursor: "pointer",
                                            fontSize: "12px",
                                            color: "black",
                                            outline: "none",
                                            width: "18px",
                                            padding: 0,
                                            marginLeft: "2px"
                                        }}
                                        title="Filter Validator"
                                    >
                                        <option value="All">All</option>
                                        <option value="Pending">Pending</option>
                                        <option value="Approved">Approved</option>
                                        <option value="Rejected">Rejected</option>
                                        <option value="Update">Update</option>
                                    </select>
                                </div>
                            </div>
                        </th>

                        <th style={{ width: "8%", textAlign: "center" }}>
                            <div>
                                <span>APPROVER</span>

                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    }}
                                >
                                    <span style={{ color: "indigo", fontSize: "12px" }}>
                                        ( {approverFilter} )
                                    </span>

                                    <select className=""
                                        value={approverFilter}
                                        onChange={(e) => setApproverFilter(e.target.value)}
                                        style={{
                                            border: "none",
                                            background: "transparent",
                                            cursor: "pointer",
                                            fontSize: "12px",
                                            color: "black",
                                            outline: "none",
                                            width: "18px",
                                            padding: 0,
                                            marginLeft: "2px"
                                        }}
                                        title="Filter Approver"
                                    >
                                        <option value="All">All</option>
                                        <option value="Pending">Pending</option>
                                        <option value="Approved">Approved</option>
                                        <option value="Rejected">Rejected</option>
                                        <option value="Update">Update</option>
                                    </select>
                                </div>
                            </div>
                        </th>

                        <th style={{ width: "5%" }}>LOCATION</th>
                        <th style={{ width: "10%" }}>COMMENTS</th>
                        <th style={{ width: "5%" }}>ACTION</th>
                        <th style={{ width: "7%" }}>CREATED AT</th>
                        <th style={{ width: "7%" }}>LAST UPDATE</th>
                    </tr>
                </thead>

                <tbody className="text-white" style={{ fontSize: "small" }}>
                    {filteredRecords.length > 0 ? (
                        filteredRecords.map((sub, index) => (
                            <tr key={sub.id}>

                                <td>{index + 1}</td>
                                <td>{sub.id}</td>
                                <td>{sub.empid}</td>
                                <td>{sub.empname}</td>
                                <td>{sub.validatorname}</td>
                                <td>{sub.title}</td>

                                {/* <td >
                                    <span
                                        className={`status-text ${sub.status === "T"
                                            ? "status-pending"
                                            : sub.status === "F"
                                                ? "status-rejected"
                                                : sub.status === "U"
                                                    ? "status-update"
                                                    : sub.status === "A"
                                                        ? "status-accepted"
                                                        : "status-unknown"
                                            }`}
                                    >
                                        {sub.status === "T"
                                            ? "Pending"
                                            : sub.status === "F"
                                                ? "Rejected"
                                                : sub.status === "U"
                                                    ? "Update"
                                                    : sub.status === "A"
                                                        ? "Accepted"
                                                        : "Unknown"}
                                    </span>
                                    <br></br>
                                    {generateStage(sub)}
                                </td> */}

                                <td> <span
                                    className={`status-text ${sub.status === "U"
                                        ? "status-update"
                                        : sub.isvalidatorapproved == "approved"
                                            ? "status-accepted"
                                            : sub.isvalidatorapproved == "rejected"
                                                ? "status-rejected"
                                                : "status-unknown"
                                        }`}
                                >
                                    {sub.status === "U"
                                        ? "Update"
                                        : sub.isvalidatorapproved == "approved"
                                            ? "Approved"
                                            : sub.isvalidatorapproved == "rejected"
                                                ? "Rejected"
                                                : "Pending"}
                                </span></td>

                                <td> <span
                                    className={`status-text ${sub.status === "U"
                                        ? "status-update"
                                        : sub.isvalidatorapproved == "rejected"
                                            ? "status-rejected"
                                            : sub.isapproverapproved == "approved"
                                                ? "status-accepted"
                                                : sub.isapproverapproved == "rejected"
                                                    ? "status-rejected"
                                                    : "status-unknown"
                                        }`}
                                >
                                    {sub.status === "U"
                                        ? "Update"
                                        : sub.isvalidatorapproved == "rejected"
                                            ? "Rejected"
                                            : sub.isapproverapproved == "approved"
                                                ? "Approved"
                                                : sub.isapproverapproved == "rejected"
                                                    ? "Rejected"
                                                    : "Pending"}
                                </span></td>

                                <td>{sub.location}</td>

                                <td title={sub.comments}>
                                    {expandedComment === index || sub.comments?.length <= 40 ? (
                                        sub.comments
                                    ) : (
                                        <>
                                            {sub.comments.substring(0, 40)}...
                                            <i
                                                onClick={() => handleSeeMore(index)}
                                                style={{
                                                    color: "black",
                                                    cursor: "pointer",
                                                    marginLeft: "5px",
                                                }}
                                            >
                                                See more
                                            </i>
                                        </>
                                    )}
                                </td>

                                <td>
                                    <div className="d-flex justify-content-center fw-bold" style={{ fontSize: "18px" }}>
                                        <i class="bi bi-eye-fill" style={{ color: "blue", cursor: "pointer" }} title="See" onClick={() => handleOpenSeeModal(sub)}></i>
                                    </div>

                                </td>

                                <td>
                                    {new Date(sub.createdat.replace(" ", "T"))
                                        .toLocaleString("en-GB", {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric"
                                        })
                                        .replace(",", "")}
                                </td>

                                <td>
                                    {new Date(sub.lastupdatedat.replace(" ", "T"))
                                        .toLocaleString("en-GB", {
                                            day: "2-digit",
                                            month: "2-digit",
                                            year: "numeric"
                                        })
                                        .replace(",", "")}
                                </td>

                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="12" style={{ textAlign: "center" }}>
                                No records available...!
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>



            <Modal
                show={showSeeModal}
                onHide={handleCloseSeeModal}
                backdrop="static"
                keyboard={false}
                fullscreen
            >
                <ApproverSeePage isApproved={true} userDetails={userDetails} handleCloseSeeModal={handleCloseSeeModal} setParentLoading={setParentLoading} />
            </Modal>

        </div>
    );
}

export default ApproverTrack;